// Reusable skeleton primitives - shimmer via Tailwind animate-pulse.
// Usage:
//   <SkeletonLine width="w-3/4" />
//   <SkeletonBlock height="h-48" />
//   <SkeletonCircle size="w-10 h-10" />

interface SkeletonLineProps {
  width?: string;
  className?: string;
}

export function SkeletonLine({ width = "w-full", className = "" }: SkeletonLineProps) {
  return (
    <div
      className={`animate-pulse bg-gray-200 dark:bg-white/10 rounded-md h-4 ${width} ${className}`}
    />
  );
}

interface SkeletonBlockProps {
  height?: string;
  width?: string;
  className?: string;
}

export function SkeletonBlock({
  height = "h-24",
  width = "w-full",
  className = "",
}: SkeletonBlockProps) {
  return (
    <div
      className={`animate-pulse bg-gray-200 dark:bg-white/10 rounded-2xl ${height} ${width} ${className}`}
    />
  );
}

interface SkeletonCircleProps {
  size?: string;
  className?: string;
}

export function SkeletonCircle({ size = "w-10 h-10", className = "" }: SkeletonCircleProps) {
  return (
    <div className={`animate-pulse bg-gray-200 dark:bg-white/10 rounded-full ${size} ${className}`} />
  );
}
